import React, { useEffect } from "react";
import Helmet from "react-helmet";
import HomepageLayout from "src/layouts/homepage";
import JSONData from "branding/site-metadata.json";
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import "./pp.css"; // Import CSS file here

export default function Privacy() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <HomepageLayout>
            <Helmet data={JSONData}><title>Privacy Policy</title></Helmet>
            <header>
                <img src="/img/mainlogo.png" alt="Main Logo" />
            </header>
            <div
                name="termly-embed"
                data-id="880281dd-03bf-4f66-a08e-626a853aac54"
                data-type="iframe"
            ></div>
            <RawFooter />
        </HomepageLayout>
    );
}
